module.exports = __webpack_public_path__ + "0c33b0798c83b455b8988641183a1102.svg";